// extracted by mini-css-extract-plugin
export default {"cls1":"UserListMenu-cls1___a583d10b5dbd557ecdc","cls2":"UserListMenu-cls2___8cd999dce7a0ea059f7 UserListMenu-cls1___a583d10b5dbd557ecdc"};